import { render } from "./ApiDocLayout.vue?vue&type=template&id=639cad8c&scoped=true"
import script from "./ApiDocLayout.vue?vue&type=script&lang=js"
export * from "./ApiDocLayout.vue?vue&type=script&lang=js"

import "./ApiDocLayout.vue?vue&type=style&index=0&id=639cad8c&scoped=true&lang=scss"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639cad8c"]])

export default __exports__